import React from 'react';
import PropTypes from 'prop-types';
import { InputLabel, FormControl, FormHelperText, Select, MenuItem, Typography } from '@material-ui/core';
import { DropdownIcon, CheckIcon } from 'sharedComponents/Icons';

const SelectComponent = ({ classes, children, label, value, onChange, helperText, readOnly, ...props }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleChange = (e) => onChange(e.target.value);

  return (
    <FormControl className={classes.root} {...props}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onOpen={handleOpen}
        onChange={handleChange}
        onClose={handleClose}
        MenuProps={{
          anchorEl,
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        }}
        inputProps={{ readOnly }}
        IconComponent={DropdownIcon}
        renderValue={(val) => children && children.find((f) => f.value === val)?.name}
      >
        {children.map((item) => (
          <MenuItem key={item.value} value={item.value} classes={{ root: classes.itemSelected }}>
            <Typography className={classes.itemName}>{item.name}</Typography>
            {item.value === value && <CheckIcon />}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

SelectComponent.propTypes = {
  value: PropTypes.string,
  label: PropTypes.node,
  children: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.node,
    }),
  ),
  classes: PropTypes.objectOf(PropTypes.string),
  onChange: PropTypes.func,
};

SelectComponent.defaultProps = {
  value: '',
  label: null,
  children: null,
  classes: {},
  onChange: () => {},
};

export default SelectComponent;
